import { render, staticRenderFns } from "./OrganizationCoursesListPage.vue?vue&type=template&id=12a70026&scoped=true&"
import script from "./OrganizationCoursesListPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationCoursesListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a70026",
  null
  
)

export default component.exports